<template>
    <b-modal
        modal-class="apprentice-default-modal create-rating-form-modal"
        :id="'create-rating-form-modal'"
        title="Nieuw beoordelingsformulier"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')"
        @ok="onOk"
        @show="onShow"
        size="md">
        <div class="create-rating-form">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    variant="danger"
                    show>
                    Naam beoordelingsformulier mag niet leeg zijn.
                </b-alert>
            </div>
            <b-form-group
                class="rating-form-name-group"
                label="Naam beoordelingsformulier"
                label-for="rating-form-input-label">
                <b-form-input
                    id="rating-form-input-label"
                    v-model="title"
                    placeholder="Typ hier de titel van het formulier">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-rating-modal-new-form-component',
    data() {
        return {
            title: '',
            hasError: false,
        };
    },

    methods: {
        onOk(vbEventmodal) {
            if (this.modalHasError()) {
                this.hasError = true;
                vbEventmodal.preventDefault();
                return;
            }

            this.$emit('input', this.title);
        },

        onShow() {
            this.title = '';
        },

        modalHasError() {
            this.hasError = false;
            return this.title === '';
        },
    },
};
</script>

<style scoped lang="scss"></style>
